import {
  JOIN_CREATE, JOIN_SAVE_FAILURE, JOIN_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    joins: []
  },
  getters: {
    joins: state => {
      return state.joins
    }
  },
  actions: {
    [JOIN_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/joins', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(JOIN_SAVE_FAILURE, res.data)
            } else {
              commit(JOIN_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [JOIN_SAVE_FAILURE] (state, data) {
      console.log('JOIN_SAVE_FAILURE')
    },
    [JOIN_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/join-new.js